import { combineReducers } from "redux";

import applicationEdit from "./applicationEdit/applicationEdit.reducer";
import businessInfo from "./applicationEntry/businessInfo/businessInfo.reducer";
import fees from "./applicationEntry/fees/fees.reducer";
import applicationList from "./applicationList/applicationList.reducer";
import { authentication } from "./authentication.reducer";
import dropdownValues from "./common/dropdownValues/dropdownValues.reducer";
import ownerPrincipalValidationInfo from "./common/ownerPrincipalValidationInfo/ownerPrincipalValidationInfo.reducer";
import filters from "./filters/filters.reducer";
import merchantFees from "./merchantInfo/fees/merchantFees.reducer";
import merchantFinancials from "./merchantInfo/financials/financial.reducer";
import merchantGeneral from "./merchantInfo/general/general.reducer";
import resultsTabs from "./merchantInfo/results/results.reducer";
import merchantTerminal from "./merchantInfo/terminal/terminal.reducer";
import pend from "./pend/pend.reducer";
import pendo from "./pendo/pendo.reducer";
import { form } from "./reduxForm/reduxForm.reducer";
import sourceFilterFiles from "./residuals/filterFiles/filterFiles.reducer";
import roles from "./roles/roles.reducer";
import agentOfficeSetup from "./systemSetup/agentOfficeSetup/agentOfficeSetup.reducer";
import agentSetup from "./systemSetup/agentSetup/agentSetup.reducer";
import { splitProfileList } from "./systemSetup/agentSetup/residualSplitProfile";
import { scheduleAList } from "./systemSetup/agentSetup/scheduleAList";
import editUser from "./systemSetup/editUser/editUser.reducer";
import feeTemplate from "./systemSetup/feeTemplates/feeTemplate.reducer";
import { users } from "./systemSetup/users";
import ui from "./ui/ui.reducer";
import financial from "./underwriting/underwritingPage/financials/financial.reducer";
import merchantInfo from "./underwriting/underwritingPage/merchantInfo/merchantInfo.reducer";
import user from "./user/user.reducer";

export { applicationEditActions } from "./applicationEdit/applicationEdit.actions";
export { businessInfoActions } from "./applicationEntry/businessInfo/businessInfo.actions";
export { feesActions } from "./applicationEntry/fees/fees.actions";
export { applicationListActions } from "./applicationList/applicationList.actions";
export { dropdownValuesActions } from "./common/dropdownValues/dropdownValues.actions";
export { ownerPrincipalValidationInfoActions } from "./common/ownerPrincipalValidationInfo/ownerPrincipalValidationInfo.actions";
export { merchantGeneralActions } from "./merchantInfo/general/general.actions";
export { resultsActions } from "./merchantInfo/results/results.actions";
export { merchantTerminalActions } from "./merchantInfo/terminal/terminal.actions";
export { merchantListActions } from "./merchantList/merchantList.actions";
export { merchantFinancialActions } from "./merchantInfo/financials/financial.actions";
export { pendActions } from "./pend/pend.actions";
export { rolesActions } from "./roles/roles.actions";
export { agentOfficeSetupActions } from "./systemSetup/agentOfficeSetup/agentOfficeSetup.actions";
export { agentSetupActions } from "./systemSetup/agentSetup/agentSetup.actions";
export { editUserActions } from "./systemSetup/editUser/editUser.actions";

export { usersActions, usersConstants, users } from "./systemSetup/users";

export {
	getScheduleAListPage,
	getScheduleAListSortBy,
	getScheduleAListSortDescending,
	scheduleAList,
	scheduleAListActions,
	scheduleAListConstants,
} from "./systemSetup/agentSetup/scheduleAList";

export {
	splitProfileList,
	getSplitProfileListPage,
	getSplitProfileListSortBy,
	getSplitProfileListSortDescending,
	splitProfileListActions,
	splitProfileListConstants,
} from "./systemSetup/agentSetup/residualSplitProfile";

export { financialActions } from "./underwriting/underwritingPage/financials/financial.actions";
export { merchantInfoActions } from "./underwriting/underwritingPage/merchantInfo/merchantInfo.actions";
export { userActions } from "./user/user.actions";
export { feeTemplateActions } from "./systemSetup/feeTemplates/feeTemplate.action";
export { merchantFeesActions } from "./merchantInfo/fees/merchantFees.actions";
export { filtersActions } from "./filters/filters.actions";

export { sourceFilterFilesActions } from "./residuals/filterFiles/filterFiles.actions";

export { applicationEditConstants } from "./applicationEdit/applicationEdit.constants";
export { businessInfoConstants } from "./applicationEntry/businessInfo/businessInfo.constants";
export { feesConstants } from "./applicationEntry/fees/fees.constants";
export { applicationListConstants } from "./applicationList/applicationList.constants";
export { dropdownValuesConstants } from "./common/dropdownValues/dropdownValues.constants";
export { ownerPrincipalValidationInfoConstants } from "./common/ownerPrincipalValidationInfo/ownerPrincipalValidationInfo.constants";
export {
	generalDropdownValues,
	generalConstants,
} from "./merchantInfo/general/general.constants";
export { resultsConstants } from "./merchantInfo/results/results.constants";
export { terminalConstants } from "./merchantInfo/terminal/terminal.constants";
export { merchantListConstants } from "./merchantList/merchantList.constants";
export { financialConstants } from "./merchantInfo/financials/financial.constants";
export { pendConstants } from "./pend/pend.constants";
export { reduxFormConstants } from "./reduxForm/reduxForm.constants";
export { rolesConstants } from "./roles/roles.constants";
export { feeTemplateConstants } from "./systemSetup/feeTemplates/feeTemplate.constants";

export { uiConstants } from "./ui/ui.constants";
export { userConstants } from "./user/user.constants";
export { merchantFeesConstants } from "./merchantInfo/fees/merchantFees.constants";
export { filtersConstants } from "./filters/filters.constants";

export { sourceFilterFilesConstants } from "./residuals/filterFiles/filterFiles.constants";

export {
	hideModal,
	hideModalEnsureSingleInstance,
	showModal,
	showModalEnsureSingleInstance,
	uiActions,
} from "./ui/ui.actions";

export type {
	HideSpinnerOverlay,
	ShowErrorNotification,
	ShowModalType,
	ShowSpinnerOverlay,
} from "./ui/ui.actions";

//Pendo
export { pendoActions } from "./pendo/pendo.actions";
export { pendoConstants } from "./pendo/pendo.constants";
export { pendoDataSelector } from "./pendo/pendo.reducer";

const appReducer = combineReducers({
	agentOfficeSetup,
	agentSetup,
	applicationEdit,
	applicationList,
	authentication,
	businessInfo,
	dropdownValues,
	editUser,
	feeTemplate,
	fees,
	filters,
	financial,
	form,
	merchantFees,
	merchantFinancials,
	merchantGeneral,
	merchantInfo,
	merchantTerminal,
	ownerPrincipalValidationInfo,
	pend,
	pendo,
	resultsTabs,
	roles,
	scheduleAList,
	sourceFilterFiles,
	splitProfileList,
	ui,
	user,
	users,
});

const rootReducer = (state, action) => {
	if (action.type === "RESET_GLOBAL_STATE") {
		return appReducer(undefined, action);
	}

	return appReducer(state, action);
};

export default rootReducer;
